import script from "./ShapeType.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeType.vue?vue&type=script&setup=true&lang=ts"

import "./ShapeType.vue?vue&type=style&index=0&id=69a29fcc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a29fcc"]])

export default __exports__